export default __webpack_public_path__ + "static/media/2.940c3046.png";